import OtpVerificationComponent from "@Components/Pages/Common/OtpVerificationComponent";
import { CartActions } from "@Redux-Store/Actions";
import { UserActions } from "@Redux-Store/Actions/UserActions";
import { apiUser } from "@Services/API/IndividualApi's/User";
import { useRouter } from "next/router";
import { useState } from "react";
import { useDispatch } from "react-redux";

interface VerifyProps {
  phoneNumber: string;
}
function VerifyOtpPage({ phoneNumber }: VerifyProps) {
  const router = useRouter();
  const [spinner, setSpinner] = useState<boolean>(false);
  const [isOtpError, setIsOtpError] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleSubmit = async (OTP: any) => {
    setSpinner(true);
    const obj = {
      phoneNumber: phoneNumber,
      code: OTP,
    };
    const queryParam = `?kind=login`;
    try {
      const response = await apiUser.verify(obj, queryParam);

      if (response) {
        setSpinner(false);
        setIsOtpError(false);
        dispatch(UserActions.getMyDetails());
        dispatch(CartActions.GetMyCart());
        if (router.query.hasOwnProperty("checkout")) {
          router.push("/checkout");
          return;
        }
        router.back();
      }
    } catch (err) {
      setIsOtpError(true);
      setSpinner(false);
      console.log(err);
    }
  };
  const handleResendAnOtp = async () => {
    const obj = {
      phoneNumber: phoneNumber,
    };
    // const response = await LoginWithOtp.post!(obj);
    const response = await apiUser.loginWithOtp(obj);
  };

  return (
    <OtpVerificationComponent
      handleSubmit={handleSubmit}
      handleResendAnOtp={handleResendAnOtp}
      spinner={spinner}
      isOtpError={isOtpError}
    />
  );
}
export default VerifyOtpPage;
